// extracted by mini-css-extract-plugin
export default {"filter":"styles__filter___GJWL_","pill":"styles__pill___lRfGL","label":"styles__label___mB9k_"};